import { Action, createReducer, on } from '@ngrx/store';
import { IValidateMobileRequest, IValidateMobileSuccess } from '../../../core/models/validate-mobile.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import {
  checkValidMobileNumberRequest,
  checkValidMobileNumberSuccess,
  checkValidMobileNumberFailure
} from '../actions/validate-mobile-number.actions';

export const validateMobileNumberFeatureKey = 'validateMobileNumber';

export interface ValidatemobileState {
  isLoading: boolean;
  loadValidateRequest: IValidateMobileRequest;
  loadValidateSuccess: IValidateMobileSuccess;
  loadValidateFailure: IGenericError<ErrorResponse>;
}

export const initialState: ValidatemobileState = {
  isLoading: false,
  loadValidateRequest: undefined,
  loadValidateSuccess: undefined,
  loadValidateFailure: undefined
};

export const reducer = createReducer(
  initialState,

  //#region Validate
  on(checkValidMobileNumberRequest, (state, action) => ({
    ...state,
    loadValidateRequest: action.request,
    isLoading: true
  })),
  on(checkValidMobileNumberSuccess, (state, action) => ({
    ...state,
    loadValidateSuccess: action.response,
    isLoading: false
  })),
  on(checkValidMobileNumberFailure, (state, action) => ({
    ...state,
    loadValidateFailure: action.error,
    isLoading: false
  }))
  //#endregion
);

//#region Validate
export const getIsMobileValidationLoading = (state: ValidatemobileState) => state.isLoading;
export const getMobileValidationRequest = (state: ValidatemobileState) => state.loadValidateRequest;
export const getMobileValidationSuccess = (state: ValidatemobileState) => state.loadValidateSuccess;
export const getMobileValidationFailure = (state: ValidatemobileState) => state.loadValidateFailure;

//#endregion
